// @flow
import * as React from 'react'
import Hotel from 'components/hotel'
import Waypoint from 'react-waypoint'
import config from 'config'

type WaypointEvent = { currentPosition: string, previousPosition: string }

type Props = {
  category: string,
  numberOfStars: number,
  hotelList: Array<Map>,
  id: string,
  request: 'loading' | 'error' | 'ready',
  topWaypointLeaveHandler: (id: string, waypointEvent: WaypointEvent) => void,
  bottomWaypointLeaveHandler: (id: string, waypointEvent: WaypointEvent) => void
}

export function HotelCategory ({
  category,
  numberOfStars,
  hotelList,
  id,
  request,
  topWaypointLeaveHandler,
  bottomWaypointLeaveHandler
}: Props) {
  const segmentClasses = `ui relaxed vertical attached ${request} hotel-category segment`
  let starOrnament = []

  for (let i = 0; i < numberOfStars; i++) {
    starOrnament.push(
      <img
        key={`star-${i}`}
        src={require('images/star-grey.svg')}
        style={{ maxWidth: '2em', height: 'auto' }}
        alt=''
        className='ui mini image'
      />
    )
  }

  return (
    <main className={segmentClasses} id={id}>
      <Waypoint
        scrollableAncestor={window}
        onLeave={({ previousPosition, currentPosition }) => {
          if (
            previousPosition === Waypoint.inside &&
            currentPosition === Waypoint.above
          ) {
            topWaypointLeaveHandler(id)
          }
        }}
        topOffset='25%'
      />

      <div className='ui text container'>
        <h2
          className='ui center aligned header'
          style={{ color: config.gradient[category][1] }}
        >
          <div className='sub header'>Die 25 besten Winterhotels mit</div>
          {numberOfStars} Sternen
          <div className='ui centered images'>{starOrnament}</div>
        </h2>
        <div />
      </div>

      <div className='ui container'>
        <div className='ui three doubling stackable cards'>
          {hotelList.map(hotel => {
            const hotelProps = {
              address: hotel.get('Adresse'),
              category: hotel.get('Kategorie'),
              description: hotel.get('Legende'),
              host: hotel.get('Gastgeber'),
              image: hotel.get('Bild'),
              name: hotel.get('Name'),
              phone: hotel.get('Telefon'),
              previousRank: hotel.get('RangimVorjahr'),
              price: hotel.get('Preis'),
              rank: parseInt(hotel.get('Rang'), 10),
              stars: parseInt(hotel.get('Sterne'), 10),
              typeOfStay: hotel.get('TypderÜbernachtung'),
              website: hotel.get('Webseite')
            }

            return <Hotel {...hotelProps} key={hotelProps.name} />
          })}
        </div>
      </div>
      <Waypoint
        scrollableAncestor={window}
        onLeave={({ previousPosition, currentPosition }) => {
          if (
            previousPosition === Waypoint.inside &&
            currentPosition === Waypoint.below
          ) {
            bottomWaypointLeaveHandler(id)
          }
        }}
        bottomOffset='25%'
      />
    </main>
  )
}



// WEBPACK FOOTER //
// ./src/components/hotelCategory/component.js